 (function (StickyNav, $, undefined) {

  var $main = $('#template'),
      $header = $('#header'),
      $window = $(window),
      $footerTitle = $('.js-footer-title');

  var bindUIActions = function () {
    $(document).scroll(function(){
        if($window.scrollTop() <= 25) {
            if($header.hasClass('mini-nav')) {
                $header.removeClass('mini-nav');
            }
        } else if(!$header.hasClass('mini-nav')) {
            $header.addClass('mini-nav');
        }
        if ($('.ui-autocomplete').length) {
          $('.ui-autocomplete').hide();
        }
    });

    $window.resize(function(){
      $main.css('margin-top',$header.height());
    });

    $footerTitle.on('click',function(){
      $(this).parent().toggleClass('is-active');
    });
  };

  StickyNav.init = function () {
    bindUIActions();
    $main.css('margin-top',$header.height());
  };

}(window.StickyNav = window.StickyNav || {}, jQuery));
